<template>
    <div class="card-body p-0">

        <status-feedback :successFeedback="successFeedback" :failFeedback="failFeedback" :errors="errors" ></status-feedback>

        <b-tabs nav-id="notifications-unread-tabs" tabs-id="notifications-unread-tabs-content">

            <b-tab label="Unread" id="notifications-unread-table">
                <card-table
                    title="Unread Messages"
                    :items="unreadMessages"
                    :headers="tableUnreadHeaders"
                    :controls="tableControls">

                    <template slot="cell" slot-scope="cellData">
                        <button @click="onMessageSelected(cellData.rowData.item)" class="btn btn-view border border-dark">View</button>
                    </template>

                </card-table>
            </b-tab>

            <b-tab label="All messages" id="notifications-read-table">
                <card-table
                    title="All Messages"
                    :items="items"
                    :headers="tableAllHeaders"
                    :controls="tableControls">

                    <template slot="cell" slot-scope="cellData">
                        <button @click="onMessageSelected(cellData.rowData.item)" class="btn btn-view border border-dark">View</button>
                        <button @click="onDelete(cellData.rowData.item)" class="btn btn-delete border border-dark">Delete</button>
                    </template>

                </card-table>
            </b-tab>

        </b-tabs>

        <div class="notification-message">
            <div v-if="selectedItem != null" class="table-responsive">
                <table class="table table-borderless">
                    <tbody>
                        <tr v-for="(property, key) in selectedItem" :key="key">
                            <th> {{key}} </th>
                            <div v-if="key.toLowerCase() === 'link'">
                                <td> <a :href="property"> {{ property }} </a> </td>
                            </div>
                            <div v-else> <td> {{ property }} </td> </div>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>

import statusFeedback from '../feedback/StatusFeedbackComponent.vue';

export default{

    components: {
        'status-feedback': statusFeedback,
    },


    props: {

        notifications: {
            type: Array,
            default: [],
        },
        // addressableType: {
        //     type: String,
        //     required: true,
        // },
        tableControls: {
            search: true,
            sort: true,
            itemsPerPage: 10,
        },
    },

    data() {

        return {

            tableUnreadHeaders: [
                { key: 'id', label: 'ticket ID' },
                { key: 'data.subject', label: 'Subject' },
                { key: 'created_at', label: 'Date' },
            ],

            tableAllHeaders: [
                { key: 'id', label: 'ticket ID' },
                { key: 'data.subject', label: 'Subject' },
                { key: 'read_at', label: 'Read At' },
                { key: 'created_at', label: 'Date' },
            ],

            errors: [],
            successFeedback: null,
            failFeedback: null,

            items: this.notifications.sort((a, b) => { return new Date(b.date) - new Date(a.date); }),
            selectedItem: null,
            markAsReadUrl: window.APP_URL + '/personal/notification-read',
            deleteUrl: window.APP_URL + '/personal/notification-delete',
        };
    },

    computed: {
        unreadMessages: function() {
            return this.items.filter((message) => { return message.read_at == null; });
        }
    },

    methods: {
        
        onMessageSelected(notification)
        {
            if (notification.read_at !== null)
            {
                this.selectedItem = notification.data;
                return;
            }

            this.markAsRead(notification);
        },

        markAsRead(notification)
        {
            window.axios.patch(this.markAsReadUrl, notification)
                .then(response => {

                    notification.read_at = response.data.read_at;
                    this.selectedItem = notification.data;

                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                    this.successFeedback = null;
                    this.failFeedback = 'Failed making message as read!';
                    this.selectedItem = notification.data;
                });
        },

        onDelete(notification)
        {
            let _this = this;

            window.axios.delete(this.deleteUrl + '/' + notification.id)
                .then(response => {

                    if (_this.selectedItem)
                    {
                        if (_this.selectedItem.id === response.data.id) {
                            _this.selectedItem = null;
                        }
                    }

                    // let index = _this.items.indexOf(response.data);
                    // _this.items.arr.splice(index, 1);

                    let index = _this.items.findIndex((x) => x.id == response.data);

                    if (index !== -1)
                    {
                        _this.items.splice(index, 1);
                        // _this.$forceUpdate();
                    }

                    this.errors = {};
                    this.successFeedback = 'Message deleted!';
                    this.failFeedback = null;

                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                    this.successFeedback = null;
                    this.failFeedback = 'Failed making message as read!';
                });
        },
    }

};

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/notifications/UserNotificationsComponent.vue